import {
  Serialized,
  SerializedConstructor,
  SerializedSecret,
} from '@langchain/core/load/serializable';

export function isSerialized(value: unknown): value is Serialized {
  if (typeof value !== 'object' || value === null) return false;
  if (!('lc' in value)) return false;
  if (!('id' in value) || !Array.isArray(value.id)) return false;
  if (!('type' in value)) return false;

  if (
    value.type !== 'secret' &&
    value.type !== 'constructor' &&
    value.type !== 'not_implemented'
  ) {
    return false;
  }
  return true;
}

export function isSerializedConstructor(
  value: unknown
): value is SerializedConstructor {
  if (!isSerialized(value)) return false;
  if (value.type !== 'constructor') return false;
  if (!('kwargs' in value)) return false;
  return true;
}

export function isSerializedSecret(value: unknown): value is SerializedSecret {
  if (!isSerialized(value)) return false;
  if (value.type !== 'secret') return false;
  return true;
}

export function createSerializedConstructor(
  id: string | string[],
  kwargs: Record<string, unknown>
): SerializedConstructor {
  return {
    lc: 1,
    type: 'constructor',
    id: Array.isArray(id) ? id : id.split('/'),
    kwargs,
  };
}
